import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Router, Link } from "@reach/router";

// const NavLink = props => (
//   <Link
//     {...props}
//     getProps={({ isCurrent }) => {
//       // the object returned here is passed to the
//       // anchor element's props
//       return {
//         style: {
//           color: isCurrent ? "black" : "white"
//         }
//       };
//     }}
//   />
// );

// const NavLink = React.forwardRef((props, ref) => (
//   <Link
//     {...props}
//     ref={ref}
//     getProps={({ isCurrent }) => {
//       // the object returned here is passed to the
//       // anchor element's props
//       return {
//         style: {
//           color: isCurrent ? "black" : "white"
//         }
//       };
//     }}
//   />
// ));

const NavLink = React.forwardRef((props, ref) => (
  <Link
    {...props}
    ref={ref}
    getProps={({ isCurrent, isPartiallyCurrent }) => {
      const isActive = isCurrent || isPartiallyCurrent;
      return {
        style: {
          color: isActive ? "black" : "white"
        }
      };
    }}
  />
));
export default NavLink;
